import RegularButton from '@/components/buttons/RegularButton'
import Carousel from '@/components/carousel/Carousel'
import Divider from '@/components/divider/Divider'
import Image from '@/components/image/Image'
import Grid from '@mui/material/Grid2'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const carouselImages = [
  '/images/statics/cleaning.jpg',
  '/images/statics/fika-3.jpg',
  '/images/statics/recording.jpg',
  '/images/history/ostersjofestivalen-4.jpg',
]

const GallerySelector: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Grid
      container
      direction="row"
      spacing={4}
      justifyContent="center"
      alignItems="stretch"
      textAlign="center"
    >
      <Grid size={12}>
        <h1>Bild- & filmarkiv</h1>
      </Grid>

      <Grid
        size={{ xs: 11, md: 3.5 }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <Image
            src="/images/statics/recording.jpg"
            alt="Inspelning"
            loading="eager"
            skeletonHeight={468}
          />
          <h2>Videos</h2>
          <p>Videos, inspelning, reportage mm</p>
        </div>
        <RegularButton
          label="Läs mer"
          onClick={() => navigate('/video-gallery?selector=all')}
        />
      </Grid>

      <Grid
        size={{ xs: 11, md: 3.5 }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <Image
            src="/images/statics/poster-image.jpg"
            alt="Poster"
            loading="eager"
            skeletonHeight={468}
          />
          <h2>Affischer</h2>
          <p>Affischer genom tiderna</p>
        </div>
        <RegularButton
          label="Läs mer"
          onClick={() => navigate('/image-gallery?selector=posters')}
        />
      </Grid>

      <Grid
        size={{ xs: 11, md: 3.5 }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <Image
            src="/images/history/ostersjofestivalen-2026/ostersjofestivalen-2026-2.jpg"
            alt="Foton"
            loading="eager"
            skeletonHeight={468}
          />
          <h2>Bilder 2020-2026</h2>
          <p>Foton från verksamheten och evenemang 2020-2026</p>
        </div>
        <RegularButton
          label="Läs mer"
          onClick={() => navigate('/image-gallery?selector=2020-2026')}
        />
      </Grid>

      <Grid
        size={{ xs: 11, md: 3.5 }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <Image
            src="/images/history/history-4.jpg"
            alt="Foton"
            loading="eager"
            skeletonHeight={468}
          />
          <h2>Historiska bilder</h2>
          <p>Historiska foton</p>
        </div>
        <RegularButton
          label="Läs mer"
          onClick={() => navigate('/image-gallery?selector=history')}
        />
      </Grid>

      <Grid size={{ xs: 11, md: 10 }} sx={{ marginY: '30px' }}>
        <Divider />
      </Grid>

      <Grid size={{ xs: 11, md: 10 }}>
        <Image src="/images/statics/groupimage-2024.jpg" alt="Gruppbild" />
        <h3>Nuvarande uppsättning - 2024</h3>
      </Grid>

      <Grid
        size={{ xs: 11, md: 10 }}
        sx={{ marginBottom: '50px', marginTop: '20px' }}
      >
        <Carousel images={carouselImages} />
      </Grid>
    </Grid>
  )
}

export default GallerySelector
